import { render, staticRenderFns } from "./spanType.vue?vue&type=template&id=4bb1ea7c&"
import script from "./spanType.vue?vue&type=script&lang=js&"
export * from "./spanType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports